import type { TFunction } from 'i18next';
import { Tag } from '../UI';
import type { TableColumn } from '../UI';
import type { RoomBookingResponse } from '../../api/generated';
import {
  actionsColumn,
  entityNameCell,
  reasonColumn,
  standardDateColumn,
  standardRepeatsColumn,
  standardTimeColumn
} from '../Bookings/shared';
import sharedStyles from '../Bookings/shared/bookings.module.css';

interface RoomBookingColumnHandlers {
  roomNameById: Map<string, string>;
  onEdit: (booking: RoomBookingResponse) => void;
  onDelete: (booking: RoomBookingResponse) => void;
}

const STAFFED_COL_WIDTH = 140;

const isStaffed = (booking: RoomBookingResponse): boolean =>
  booking.mandatoryStaffCompetenceRequirements.length > 0 ||
  booking.flexStaffCompetenceRequirements.length > 0;

export const getRoomBookingColumns = (
  t: TFunction,
  { roomNameById, onEdit, onDelete }: RoomBookingColumnHandlers
): TableColumn<RoomBookingResponse>[] => [
  {
    key: 'room',
    header: t('room-booking-col-room'),
    render: (booking) =>
      entityNameCell({ names: [roomNameById.get(booking.roomId) ?? booking.roomId] })
  },
  standardDateColumn(t, 'room-booking-col-date'),
  standardRepeatsColumn(t, 'room-booking-col-repeats'),
  standardTimeColumn(t, 'room-booking-col-time'),
  reasonColumn(t, 'room-booking-col-reason'),
  {
    key: 'staffed',
    header: t('room-booking-col-staffing'),
    width: STAFFED_COL_WIDTH,
    render: (booking) =>
      isStaffed(booking) ? (
        <Tag label={t('room-booking-staffed')} />
      ) : (
        <span className={sharedStyles.muted}>{t('room-booking-block-only')}</span>
      )
  },
  actionsColumn(t, {
    editKey: 'room-booking-edit',
    deleteKey: 'room-booking-delete-title',
    onEdit,
    onDelete
  })
];
